const Columns = [{
    name: 'rental_id',
    value: 'rental.rental_no',
    sortable: true,
    width: 130,
}, {
    name: 'customer_id',
    value: 'customer.customer_no',
    sortable: true,
    width: 125,
}, {
    name: 'plate_no',
    value: 'scooter.plate',
    sortable: true,
    width: 120,
}, {
    name: 'reserve_time',
    value: 'reservation_time',
    sortable: true,
    width: 168,
}, {
    name: 'start_time',
    value: 'start_time',
    sortable: true,
    width: 160,
}, {
    name: 'end_time',
    value: 'end_time',
    sortable: true,
    width: 160,
}, {
    name: 'duration',
    value: 'duration',
    sortable: true,
    width: 140,
}, {
    name: 'rental_status',
    value: 'scooter.rental_state',
    sortable: true,
    width: 110,
}, {
    name: 'price',
    value: 'price',
    sortable: true,
    width: 89,
}, {
    name: 'payment_status',
    value: 'payment_status',
    sortable: true,
    width: 110,
}, {
    name: 'corporate_type',
    value: 'customer.corporate_type',
    sortable: true,
    width: 116,
}, {
    name: 'distance',
    value: 'distance',
    sortable: true,
    width: 100,
}, {
    name: 'user_travel_pass_end_time',
    value: 'rental.daypass_end_time',
    sortable: false,
    width: 160,
}];

export default Columns;
